import * as moment from "moment";


export function GetTimeAfterHours(time: string, hoursToAdd: number) {
    const momentTime = moment(time);
    let finalTime = moment(time);
    let hoursPassed = 0;

    while (hoursPassed < hoursToAdd) {
        finalTime = momentTime.add(1, `hours`);

        if (finalTime.hour() >= 22) {
            finalTime.add(8, `hours`);
        }

        hoursPassed++;
    }

    return finalTime.format(`lll`);
}
